export const route = {
  // 기본
  default: "/",

  // 홈
  home: "/home",

  // 금고
  coffer: "/coffer",

  //유언
  testament: "/testament",
  testament_add: "/testament/add",
  testament_edit: "/testament/edit",
  testament_detail: "/testament/detail",

  //서재
  library: "/library",
  library_add: "/library/add",
  library_detail: "/library/detail",
  library_edit: "/library/edit",

  //전문가
  expert: "/expert",
  expert_photo: "/expert/photo",
  expert_inheritance: "/expert/inheritance",
  expert_nursing: "/expert/nursing",
  expert_funeral: "/expert/funeral",
  contact: "/expert/contact",
  contact_expert: "/expert/contact/expert",
  contact_payment: "/expert/contact/payment",

  //회원가입
  login: "/login",
  login_find_id: "/login/find-id",
  login_find_pw: "/login/find-pw",
  login_find_pw_complete: "/login/find-pw/complete",
  join: "/join",
  join_complete: "/join/complete",

  //더보기
  more: "/more",
  terms: "/terms",
  policy: "/policy",
};
